<template lang="pug">
#order_detail
  .container
    breadcrumb(v-bind:pageName="pageName")
    p.action_btns
      p.back_btn(@click="goPreviousPage")
        |
        font-awesome-icon.mr-1(:icon="['fas', 'arrow-left']") 
        | 返回訂單列表
  .container.pb-5
    .news_card.my-4.border-radius-10
      .head.d-flex.justify-content-between
        p.order_no 訂單編號 {{ orderDetail.serial_number }}
          span ｜ {{ formatDate(orderDetail.created) }}
        p(
          :class="{ status_progress: '待處理' == orderDetail.state_description || '處理中' == orderDetail.state_description, status_unpaid: '未付款' == orderDetail.state_description || '查帳中' == orderDetail.state_description, status_paid: '已付款' == orderDetail.state_description }"
        ) {{ orderDetail.state_description }}
      hr
      .body
        .product.course.d-flex.flex-column.flex-md-row.align-items-center.my-4
          .product_category.mb-3
            p 購買課程
          .product_contents.w-100
            p.course_group.text-center.text-md-left.mb-3 {{ orderDetail.program_product_group_name }}

            .product_content.py-3.border-bottom.d-flex.justify-content-between.align-items-center(
              v-for="course in courseList"
            )
              .course_wrapper.flex-grow-1
                p {{ course.program_product_name }} X{{ course.quantity }}
                .course_content.ml-md-3.mb-3(
                  v-if="course.program_product.program_product_specs && course.program_product.program_product_specs.length > 0"
                )
                  p(
                    v-for="spec in course.program_product.program_product_specs"
                  ) {{ spec.name }}
                    span {{ spec.val }}
              p.price ${{ course.total_price }}
        hr(v-if="extraList.length > 0")
        .product.add.d-flex.flex-column.flex-md-row.align-items-center(
          v-if="extraList.length > 0"
        )
          .product_category
            p 加購商品
          .product_wrapper.d-flex.flex-column.justify-content-start.align-items-start
            .product_content.d-flex.justify-content-between.align-items-center(
              v-for="extra in extraList"
            )
              .product_image.d-flex.align-items-center
                img(
                  v-if="extra.program_product.photo",
                  :src="extra.program_product.photo.image"
                )
                p {{ extra.program_product_name }} X{{ extra.quantity }}
              p.price ${{ extra.total_price }}
        hr(v-if="discountList && discountList.length > 0")
        .product.add.d-flex.flex-column.flex-md-row.align-items-center(
          v-if="discountList && discountList.length > 0"
        )
          .product_category
            p 折扣
          .product_wrapper.d-flex.flex-column.justify-content-start.align-items-start
            .product_content.d-flex.justify-content-between.align-items-center(
              v-for="discount in discountList"
            )
              .product_image.d-flex.align-items-center
                p.discount {{ discount.plan_name }} X{{ discount.quantity }}
              p.price.discount -${{ discount.total_discount }}
        hr
        .total_price
          .total_price_wrapper.d-flex.align-items-center.justify-content-end
            p.total 總金額
            p.price $
              span {{ orderDetail.price }}
        hr
        .check_info
          .arrow_head.text-center 訂單詳細資訊
            font-awesome-icon.ml-1(
              :icon="['fas', 'caret-right']",
              data-toggle="tooltip",
              data-placement="right",
              title="訂單詳細資訊"
            ) 
          .check_info_body.d-flex.flex-column.flex-md-row.justify-content-around.mt-3(
            v-if="orderDetail.group_size <= 1 && orderDetail.program_apply_targets && orderDetail.program_apply_targets.length > 0"
          )
            .left
              li
                p.title 學生姓名
                p.content {{ orderDetail.program_apply_targets[0].name }}
              li
                p.title 生日
                p.content {{ orderDetail.program_apply_targets[0].birthday }}
              li
                p.title 身分證字號
                p.content {{ orderDetail.program_apply_targets[0].citizen_id }}
              li
                p.title 學校名稱/年級
                p.content {{ orderDetail.program_apply_targets[0].school }} {{ orderDetail.program_apply_targets[0].grade }}
              li
                p.title 籃球學習經驗
                p.content {{ orderDetail.program_apply_targets[0].basketball_experience }}
              li
                p.title 課程主要目標
                p.content {{ orderDetail.program_apply_targets[0].basketball_goal }}
              li
                p.title 健康狀況
                p.content {{ orderDetail.program_apply_targets[0].health_condition }}
              li
                p.title 過敏食物
                p.content {{ orderDetail.program_apply_targets[0].food_allergens }}
            .right
              li
                p.title 家長姓名
                p.content {{ orderDetail.program_apply_targets[0].legal_representative_name }}
              li
                p.title 家長出生年月日
                p.content {{ orderDetail.program_apply_targets[0].legal_representative_birthday }}
              li
                p.title 家長身分證字號
                p.content {{ orderDetail.program_apply_targets[0].legal_representative_citizen_id }}
              li
                p.title 聯絡電話
                p.content {{ orderDetail.program_apply_targets[0].parent_phone }}
              li
                p.title LINE ID
                p.content {{ orderDetail.program_apply_targets[0].parent_line_id }}

          b-tabs.multiple.w-100(
            v-if="orderDetail.group_size > 1 && orderDetail.program_apply_targets && orderDetail.program_apply_targets.length > 0",
            v-model="tabIndex"
          )
            b-tab(
              v-for="(student, index) in orderDetail.program_apply_targets",
              :key="index",
              :title="'學生' + (index + 1)"
            )
              .check_info_body.d-flex.flex-column.flex-md-row.justify-content-around.mt-3
                .left
                  li
                    p.title 學生姓名
                    p.content {{ student.name }}
                  li
                    p.title 生日
                    p.content {{ student.birthday }}
                  li
                    p.title 身分證字號
                    p.content {{ student.citizen_id }}
                  li
                    p.title 學校名稱/年級
                    p.content {{ student.school }} {{ student.grade }}
                  li
                    p.title 籃球學習經驗
                    p.content {{ student.basketball_experience }}
                  li
                    p.title 課程主要目標
                    p.content {{ student.basketball_goal }}
                  li
                    p.title 健康狀況
                    p.content {{ student.health_condition }}
                  li
                    p.title 過敏食物
                    p.content {{ student.food_allergens }}
                .right
                  li
                    p.title 家長姓名
                    p.content {{ student.legal_representative_name }}
                  li
                    p.title 家長出生年月日
                    p.content {{ student.legal_representative_birthday }}
                  li
                    p.title 家長身分證字號
                    p.content {{ student.legal_representative_citizen_id }}
                  li
                    p.title 聯絡電話
                    p.content {{ student.parent_phone }}
                  li
                    p.title LINE ID
                    p.content {{ student.parent_line_id }}

        .qa_record
          .arrow_head.text-center 問答紀錄
            font-awesome-icon.ml-1(
              :icon="['fas', 'caret-right']",
              data-toggle="tooltip",
              data-placement="right",
              title="問答紀錄"
            ) 

          .qa_record_body
            .msg(v-for="question in orderDetail.program_order_replies")
              .msg_title.mt-5(v-if="question.is_from_user")
                |
                span.msg_name {{ $store.state.user.userEmail }}
                | 於
                span.msg_date {{ messageTime(question.created) }}
              .question(v-if="question.is_from_user") 
                p {{ question.message }}
              .msg_title.mt-5.text-right(v-if="!question.is_from_user") 
                |
                span.msg_name 管理員
                | 於
                span.msg_date {{ messageTime(question.created) }}
              .answer.d-flex.flex-column.flex-md-row(
                v-if="!question.is_from_user"
              ) 
                .answer_content {{ question.message }}
            hr
            .text.d-flex(
              v-if="orderDetail.state_description != '已付款' && orderDetail.state_description != '已取消'"
            )
              textarea(placeholder="請在此輸入您的留言...", v-model="questionMessage")
              .send_btn(@click="sendQuestion") 送出
  dialog-success(
    v-if="successDialogShow",
    :title="successDialogTitle",
    :content="successDialogContent"
  )
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getOrderByID, sendQuestion } from "@/api/ecommerce";
import moment from "moment";
import { errorMessage } from "@/utils/message";
import DialogSuccess from "@/components/login/DialogSuccess";
import DialogLoading from "@/components/dialog/DialogLoading";

export default {
  name: "OrderDetail",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    "dialog-success": DialogSuccess,
    "dialog-loading": DialogLoading,
  },
  data() {
    return {
      pageName: "訂單詳細",
      tabIndex: 0,
      orderDetail: {},
      courseList: [],
      extraList: [],
      discountList: [],

      questionMessage: "",
      successDialogShow: false,
      successDialogTitle: "",
      successDialogContent: "",
      loadingDialogShow: false,
      loadingContent: "留言中....",
      statusStyle: {
        color: "",
      },
    };
  },
  created() {
    this.getOrderByID(this.$route.query.id);
  },
  methods: {
    getOrderByID(id) {
      getOrderByID(id).then((response) => {
        this.orderDetail = response.data;

        this.courseList = [];
        this.extraList = [];
        for (let index in this.orderDetail.program_order_items) {
          let temp = this.orderDetail.program_order_items[index];
          if (temp.is_additional) {
            this.extraList.push(temp);
          } else {
            this.courseList.push(temp);
          }
        }

        this.discountList = this.orderDetail.program_order_discounts;
      });
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    sendQuestion() {
      this.loadingDialogShow = true;
      let inputData = {
        message: this.questionMessage,
        is_from_user: true,
        program_order: this.orderDetail.id,
      };
      sendQuestion(inputData)
        .then(() => {
          this.loadingDialogShow = false;
          this.getOrderByID(this.$route.query.id);
          this.successDialogShow = true;
          this.successDialogTitle = "提問成功";
          this.successDialogContent = "請等待管理員的回覆";
          this.questionMessage = "";
          setTimeout(() => {
            this.successDialogShow = false;
            this.successDialogTitle = "";
            this.successDialogContent = "";
          }, 1500);
        })
        .catch((error) => {
          this.loadingDialogShow = false;
          errorMessage(this, "提問失敗", error.response.data.error_msg);
        });
    },
    messageTime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm");
    },
    goPreviousPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/enroll/radio_btn_item";
p,
span {
  margin: 0;
  letter-spacing: 1px;
}

#order_detail {
  position: relative;
  height: auto;
  position: relative;
}

.back_btn {
  font-size: 14px;
  cursor: pointer;
  color: #6d7278;
}

.news_card {
  padding-left: 0;
  padding-right: 0;
}

.head {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 10px;

  .status_paid {
    color: #67c23a;
  }

  .status_progress {
    color: #e6a23c;
  }

  .status_unpaid {
    color: #f56c6c;
  }
}

.body {
  padding-left: 40px;
  padding-right: 40px;
}

.product {
  width: 100%;
  min-height: 100px;
  padding-right: 30px;
}

.product_category {
  width: 180px;
  text-align: center;
  color: $c-text;
  font-size: 18px;
  flex-shrink: 0;
  font-weight: bold;
}

.product_wrapper {
  width: 100%;
}

.course_group {
  font-weight: 500;
}

.product_content {
  flex-grow: 1;
  width: 100%;

  &:last-child {
    border: none !important;
  }

  img {
    width: 60px;
    height: 60px;
    margin-right: 15px;
  }

  .course_wrapper {
    padding-right: 30px;

    & > p {
      margin: 0;
      font-size: 18px;
      font-weight: 400;
    }
  }

  .price {
    font-weight: 500;
  }

  .discount {
    color: #e6a23c;
  }
}

.course_content {
  margin-top: 15px;
  padding: 15px;
  border-radius: 10px;
  background-color: $color_bg_white;

  p {
    margin-bottom: 10px;
  }
}

.total_price_wrapper {
  padding-right: 30px;

  p {
    font-size: 14px;
    color: #6d7278;
  }

  p.price {
    color: $color_red;
    margin-left: 10px;

    span {
      font-size: 28px;
      font-weight: 400;
    }
  }
}

.arrow_head {
  font-size: 24px;
  color: $c-text;
  margin-bottom: 20px;
}

.check_info_body {
  background: $color_bg_white;
  border-radius: 10px;
  padding: 30px;

  li {
    list-style: none;

    p {
      display: inline-block;
    }

    .title {
      width: 120px;
      font-size: 14px;
      color: #6d7278;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .content {
      font-size: 16px;
    }
  }
}

.qa_record {
  margin-top: 20px;

  .text {
    margin-top: 40px;
  }
  textarea {
    width: calc(100% - 140px);
    margin-left: 70px;
    border-radius: 10px;
    padding: 20px;
    border: 1px solid #979797;
  }

  .send_btn {
    margin: auto;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: #6d7278;
    }
  }
}

.msg {
  margin-bottom: 40px;

  .msg_title {
    font-size: 14px;
    font-weight: normal;
    margin-left: 20px;

    .msg_name {
      font-weight: 600;
      margin-right: 10px;
    }

    .msg_date {
      color: $c-sub-text;
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  .question {
    margin-left: 20px;
    margin-top: 20px;
    background: rgba($color_blue, 0.5);
    border-radius: 10px;
    padding: 20px;
    margin-right: 70px;

    p {
      font-size: 20px;
      font-weight: normal;
      margin: 0;
    }
  }

  .answer {
    background: $color_bg_white;
    border-radius: 10px;
    padding: 20px;
    margin-left: 70px;
    margin-top: 15px;

    .answer_status {
      width: 80px;
      height: 100%;
      margin: auto;
      flex-shrink: 0;
      color: $color_red;
    }

    .answer_status.replied {
      color: #000000;
    }

    .answer_content {
      flex-grow: 1;
      color: $c-sub-text;
    }
  }
}

::v-deep .nav-tabs .nav-link {
  color: $color_water_blue;
}

::v-deep .nav-tabs .nav-link.active {
  color: $c-text;
}

::v-deep .tabs {
  margin-top: 30px;
}

@media (max-width: 767px) {
  .head {
    .order_no {
      span {
        display: block;
      }
    }
  }
  .body {
    padding-left: 20px;
    padding-right: 20px;
  }

  .product {
    padding-right: 0;
  }

  .product_category {
    margin-bottom: 24px;
    p {
      font-size: 14px;
    }
  }

  .product_content {
    p {
      font-size: 16px;
    }

    p.price {
      margin-left: 10px;
    }

    img {
      width: 40px;
      height: 40px;
      min-width: 40px;
    }
  }

  .total_price_wrapper {
    padding-right: 0;
  }

  .msg {
    .msg_title > .msg_name {
      display: block;
    }

    .question {
      font-size: 18px;
      margin-right: 30px;
    }

    .answer {
      margin-left: 30px;
      .answer_content {
        margin-top: 10px;
      }
    }
  }

  .qa_record textarea {
    margin-left: 0;
    width: calc(100% - 70px);
  }
}

@media (max-width: 575px) {
  .product_content {
    .course_wrapper {
      padding-right: 5.2vw;
    }
  }
}
</style>
